var map = {
  "./mobile": [
    "4773",
    9,
    "95797",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "98600",
    "67508",
    "89759"
  ],
  "./desktop/SidebarMapping": [
    "26583",
    9,
    "9598",
    "35629",
    "30734",
    "88393",
    "65612"
  ],
  "./desktop": [
    "92929",
    9,
    "76225",
    "62815",
    "12092",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "98600",
    "67508",
    "34485"
  ],
  "./mobile/index": [
    "4773",
    9,
    "95797",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "98600",
    "67508",
    "89759"
  ],
  "./desktop/index.js": [
    "92929",
    9,
    "76225",
    "62815",
    "12092",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "98600",
    "67508",
    "34485"
  ],
  "./desktop/index": [
    "92929",
    9,
    "76225",
    "62815",
    "12092",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "98600",
    "67508",
    "34485"
  ],
  "./mobile/Greetingshow.js": [
    "45323",
    9,
    "67508",
    "12598"
  ],
  "./mobile/Greetingshow.scss": [
    "41183",
    7,
    "79619"
  ],
  "./desktop/Greetingshow.js": [
    "1831",
    9,
    "67508",
    "71068"
  ],
  "./desktop/Greetingshow.scss": [
    "34005",
    7,
    "75653"
  ],
  "./mobile/Greetingshow": [
    "45323",
    9,
    "67508",
    "12598"
  ],
  "./desktop/SidebarMapping.js": [
    "26583",
    9,
    "9598",
    "35629",
    "30734",
    "88393",
    "65612"
  ],
  "./desktop/": [
    "92929",
    9,
    "76225",
    "62815",
    "12092",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "98600",
    "67508",
    "34485"
  ],
  "./mobile/": [
    "4773",
    9,
    "95797",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "98600",
    "67508",
    "89759"
  ],
  "./desktop/Greetingshow": [
    "1831",
    9,
    "67508",
    "71068"
  ],
  "./mobile/index.js": [
    "4773",
    9,
    "95797",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "98600",
    "67508",
    "89759"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 19998;
module.exports = __rspack_async_context;
